import styled from "styled-components";
import { TopBannerDefaultBox } from './top-banner.default.box'

export const TopBannerSIBox = styled(TopBannerDefaultBox)`
  background-color: ${({theme}) => theme.colors.backgroundDark};
`;